import { connect } from "react-redux";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Actions as PAYROLL_ACTIONS } from "../../store/actions/payrollActions";
import { useEffect } from "react";
import { format, parse } from "date-fns";
import { validateFloat } from "@/components/common/validation/Validators";
import { useState } from "react";

const HolidayPayModal = ({
	modalStatus,
	closeModal,
	agreementId,
	getHolidayPay,
	weeklyPay,
	currency,
	allowance,
	payrollUpdateAllowance,
}) => {
	const [forceWeeklyPay, setForceWeeklyPay] = useState(allowance?.forceWeeklyPay || allowance?.avgWeeklyPay || 0);

	useEffect(() => {
		if (!modalStatus) return;
		getHolidayPay(agreementId);
		setForceWeeklyPay(allowance?.forceWeeklyPay || allowance?.avgWeeklyPay || 0);
	}, [modalStatus]);

	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto", height: "100vh" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "60%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Holiday Pay Breakdown</h3>
						</div>
						<div className="block-content">
							<div
								style={{
									height: "50vh",
									overflow: "auto",
									border: "1px solid gray",
									marginBottom: "1rem",
								}}
							>
								<table className="js-table-sections table table-hover">
									<thead
										style={{
											position: "sticky",
											top: 0,
											borderBottom: "1px solid",
											background: "white",
										}}
									>
										<tr>
											<th>Week Starting</th>
											<th>Pay</th>
											<th>Weekly Hours</th>
											<th>Equivalent Days</th>
											{/* <th width="5%"></th> */}
										</tr>
									</thead>
									<tbody>
										{weeklyPay?.map(({ week, pay, days, hours }) => {
											return (
												<tr key={`${agreementId}-${week}`}>
													<td>
														{format(parse(week, "yyyy-MM-dd", new Date()), "do MMM yyyy")}
													</td>
													<td>
														{currency}
														{pay}
													</td>
													<td>{hours}</td>
													<td>{days}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div>
							<div className="col-xs-3 pull-right">
								<button
									className="btn btn-success"
									onClick={() => {
										payrollUpdateAllowance({
											...allowance,
											forceWeeklyPay,
                                            employeeID: agreementId,
										});
										closeModal();
									}}
								>
									Update Weekly Pay
								</button>
							</div>
							<div className="col-xs-3 pull-right">
								<div className="form-material">
									<label htmlFor="forceWeeklyPay">Weekly Pay</label>
									<input
										id="forceWeeklyPay"
										type="text"
										className="form-control"
										value={forceWeeklyPay}
										onChange={(e) => setForceWeeklyPay(validateFloat(e.target.value))}
									/>
								</div>
							</div>
							{allowance?.forceWeeklyPay && (
								<div className="col-xs-3">
									<button
										className="btn btn-default"
										onClick={() => {
											payrollUpdateAllowance({
												...allowance,
												forceWeeklyPay: undefined,
                                                resetWeeklyPay: true,
                                                employeeID: agreementId,
											});
                                            closeModal();
										}}
									>
										Reset Weekly Pay
									</button>
								</div>
							)}
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		modalStatus: !!state.payroll?.holidayPayModal,
		agreementId: state.payroll?.holidayPayModal?.agreementId,
		allowance: state.payroll?.holidayPayModal?.allowance,
		weeklyPay: state.payroll?.holidayPayModal?.weeklyPay,
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(PAYROLL_ACTIONS.toggleHolidayPayModal({})),
	payrollUpdateAllowance: (input) => dispatch(PAYROLL_ACTIONS.payrollUpdateAllowance(input)),
	getHolidayPay: (agreementId) => dispatch(PAYROLL_ACTIONS.getHolidayPay(agreementId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HolidayPayModal);
